
import { CalendarEvent } from "@/models/calendar-event";
import { GoogleCalendarService } from "@/services/google-calendar-service";
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			localEvent: new CalendarEvent(),
			googleEvent: GoogleCalendarService.createNewCalendarEventObject(),
		};
	},
	methods: {
		selectType(eventType:string) {
			this.$emit("eventType", eventType);
			this.close();
		},
		close() {
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
